
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Swal from "sweetalert2";
import { API_BASE_URL, UPDATE_CATEGORY } from '../../../Config';
import SpinLoader from '../../../feature-module/loader/SpinLoader';

const EditCategoryList = ({ categoryObj }) => {

    const [userDataSession, setUserDataSession] = useState([]);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);

        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);

    // const [categoryEditData, setCategoryEditData] = useState({});
    const [formData, setFormData] = useState({});
    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);

    // Update categoryEditData when categoryObj changes
    useEffect(() => {
        if (categoryObj) {

            setFormData({
                Id: categoryObj.Id,
                OrgId: userDataSession.OrgId,
                UpdatedBy: userDataSession.UserId,
                Name: categoryObj.Name,
                Code: categoryObj.Code,
                Description: categoryObj.Description == 'NULL' ? "" : categoryObj.Description,
                IsDefault: categoryObj.IsDefault,
                IsActive: categoryObj.IsActive ? 1 : 0,
                ImagePath: "NULL",
                ImageUrl: "NULL"
            });
        }
    }, [categoryObj]);

    // Handler for form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnLoading(true);

        let updatedFormData = { ...formData };
        updatedFormData.UpdatedBy = userDataSession.UserId;
        updatedFormData.OrgId = userDataSession.OrgId;
        updatedFormData.ImagePath = "NULL";
        updatedFormData.ImageUrl = "NULL";
        updatedFormData.Description = formData.Description === "" ? "NULL" : formData.Description;

        const dataToSubmit = {
            ...updatedFormData,
            IsDefault: updatedFormData.IsDefault ? 1 : 0
        };
        console.log(updatedFormData, 'daat to api');

        fetch(`${API_BASE_URL}${UPDATE_CATEGORY}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSubmit),
        })
            .then(response => response.json())
            .then(data => {
                console.log(data.ResultData, 'response')
                if (data.ResultData[0]['Status'] == 'Success') {
                    setSubmitBtnLoading(false);
                    Swal.fire({
                        title: `Category edited Successfully.`,
                        icon: "success",
                    }).then((result) => {
                        if (result.isConfirmed || result.isDismissed) {
                            window.location.reload();
                        }
                    });
                } else {
                    setSubmitBtnLoading(false);
                    Swal.fire({
                        title: "Error",
                        text: "Failed to Request Submit.",
                        icon: "error",
                    });
                }
            })
            .catch(error => {
                setSubmitBtnLoading(false);
                console.error('Error updating category:', error);
            });
    };

    // Handler to update formData on input change
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };    

    return (
        <div>
            {submitBtnLoading&&(<SpinLoader/>)}
            {/* Edit Category */}
            <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRightCategoryEdit"
                aria-labelledby="offcanvasRightLabel"
                style={{ minWidth: '400px' }}
            >
                <div className="offcanvas-header">
                    <h4 id="offcanvasRightLabel">Edit Category</h4>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div> <hr/>
                <div className="offcanvas-body">
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label">Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="Name"
                                    value={formData.Name || ''}
                                    onChange={handleInputChange}
                                />
                            </div>
                            
                            <div className="mb-3">
                                <label className="form-label">Code</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="Code"
                                    value={formData.Code || ''}
                                    onChange={handleInputChange}
                                    maxLength={5}
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Description</label>
                                <textarea
                                    className="form-control"
                                    name="Description"
                                    value={formData.Description || ''}
                                    onChange={handleInputChange}
                                    placeholder='Enter notes'
                                ></textarea>
                            </div>
                            <div className="mb-0">
                                <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                                    <span className="status-label">IsDefault</span>
                                    <input
                                        type="checkbox"
                                        id="IsDefault"
                                        className="check"
                                        name="IsDefault"
                                        checked={formData.IsDefault}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="IsDefault" className="checktoggle"></label>
                                </div>
                            </div>
                            
                            <div className="mt-1">
                                <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                                    <span className="status-label">Active</span>
                                    <input
                                        type="checkbox"
                                        id="IsActive"
                                        className="check"
                                        name="IsActive"
                                        checked={formData.IsActive}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="IsActive" className="checktoggle"></label>
                                </div>
                            </div>

                            <div className="modal-footer-btn">
                                <button
                                    type="button"
                                    className="btn btn-cancel me-2"
                                    data-bs-dismiss="offcanvas"
                                    aria-label="Close"
                                     disabled={submitBtnLoading}
                                >
                                    Cancel
                                </button>
                                <button type='submit' className="btn btn-submit"
                                 disabled={submitBtnLoading}>
                                    {submitBtnLoading ? 'Submitting..' : 'Save Changes'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                {/* /Edit Category */}
            </div>
    )
};

EditCategoryList.propTypes = {
    categoryObj: PropTypes.object.isRequired,
};

export default EditCategoryList;
